import { render } from "./DataFlowSaveModal.vue?vue&type=template&id=b2923710"
import script from "./DataFlowSaveModal.vue?vue&type=script&lang=js"
export * from "./DataFlowSaveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__